import { Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

@Pipe({
  name: 'planes',
  standalone: true,
})
export class PlanesPipe implements PipeTransform {
  constructor(private translocoService: TranslocoService) {}

  transform(planes: string[], activeLang?: string) {
    if (!planes || planes.length === 0) return null;

    return planes
      .map(p => this.translocoService.translate(p, {}, activeLang))
      .join(', ');
  }
}
